import { lazy, useMemo, type FC } from 'react';
import type { HydrogenOperatorBookingOverviewRequestParams } from 'src/apis/hydrogen-fcfs/types';
import { useHydrogenFcfsRootLink } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import { useHydrogenOperatorBookingOverview } from 'src/apis/hydrogen-fcfs/use-hydrogen-operator-booking-overview';
import { PageSpinner } from 'src/components/spinner-container';
import { useHydrogenOperatorBookingOverviewPageParams } from 'src/pages/h2/fcfs/operator-bookings/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const HydrogenOperatorBookingOverview: FC = () => {
  const pageParams = useHydrogenOperatorBookingOverviewPageParams();
  const url = useHydrogenFcfsRootLink('bookingOverviewOperator');

  const requestParams = useMemo(
    () =>
      ({
        ...pageParams.value,
        networkPointOrBundleId: pageParams.value.networkPointOrBundle?.value,
        shipperOrganisationId: pageParams.value.shipperOrganisation?.value,
      }) satisfies HydrogenOperatorBookingOverviewRequestParams,
    [pageParams.value]
  );

  const overviewRequest = useHydrogenOperatorBookingOverview({
    url,
    params: requestParams,
  });

  if (!overviewRequest.response) return <PageSpinner />;

  return (
    <Page
      pageParams={pageParams}
      requestParams={requestParams}
      overviewRequest={overviewRequest}
    />
  );
};
